module.exports = __webpack_public_path__ + "static/media/stc.d721886a.png";